const state = {
  alertDialogs: [],
  confirmDialog: [],
  promptDialog: [],

  snackbars: [],
  isOnline: true,
  isAvailableUpdate: false
};

const getters = {
  snackbars: state => state.snackbars,
  isOnline: state => state.isOnline,
  isAvailableUpdate: state => state.isAvailableUpdate
};

const mutations = {
  SET_ONLINE_STATUS: (state, params) => {
    state.isOnline = params;
  },

  SET_AVAILABLE_UPDATE_STATUS: (state, params) => {
    state.isAvailableUpdate = params;
  },

  SET_ALERT: (state, params) => {
    let newAlert = {
      isAlert: true,
      title: params.title,
      resolver: params.resolver,
      content: params.content
    };
    state.alertDialogs.push(newAlert);
  },

  SET_CONFIRM: (state, params) => {
    let newConfirm = {
      isConfirm: true,
      title: params.title,
      resolver: params.resolver,
      content: params.content,
      rejecter: params.rejecter,
      customButtons: params.customButtons
    };
    state.confirmDialog.push(newConfirm);
  },

  SET_PROMPT: (state, params) => {
    let newPrompt = {
      isConfirm: true,
      title: params.title,
      label: typeof params.label != "undefined" ? params.label : null,
      placeholder: typeof params.placeholder != "undefined" ? params.placeholder : null,
      rules: typeof params.rules != "undefined" ? params.rules : [],
      model: typeof params.model != "undefined" ? params.model : null,
      textarea: params.textarea,
      resolver: params.resolver,
      content: params.content,
      rejecter: params.rejecter
    };
    state.promptDialog.push(newPrompt);
  },

  RESOLVE_ALERT: (state, alert) => {
    alert.resolver();
    state.alertDialogs.splice(state.alertDialogs.indexOf(alert), 1);
  },
  ACCEPT_DIALOG: (state, dialog) => {
    dialog.resolver(typeof dialog.result !== "undefined" ? dialog.result : true);
    state.confirmDialog.splice(state.confirmDialog.indexOf(dialog), 1);
  },

  CANCEL_DIALOG: (state, dialog) => {
    dialog.rejecter();
    state.confirmDialog.splice(state.confirmDialog.indexOf(dialog), 1);
  },
  ACCEPT_PROMPT: (state, dialog) => {
    dialog.resolver(dialog.model);
    state.promptDialog.splice(state.promptDialog.indexOf(dialog), 1);
  },

  CANCEL_PROMPT: (state, dialog) => {
    dialog.rejecter();
    state.promptDialog.splice(state.promptDialog.indexOf(dialog), 1);
  },

  ADD_SNACKBAR: (state, snackbarObject) => {
    state.snackbars.push(snackbarObject);
  }
};

const actions = {
  //example
  // let result = this.$store.dispatch('alertDialog', {content: "Test", title: "TEstujemy"});
  // result.then(function(){
  //     console.log("Callback test");
  // });
  alertDialog: ({ commit }, params) => {
    return new Promise(resolve => {
      commit("SET_ALERT", {
        resolver: resolve,
        content: params.content,
        title: params.title
      });
      //isAlertResolver = resolve;
    });
  },

  //example
  // let result = this.$store.dispatch('confirmDialog', {content: "Test", title: "Confirm test", customButtons: [{value: 'no', text: 'Nie'}] );
  // result.then(()=>{
  //     alert("Potwierdzono");
  // }).catch(function () {
  //     alert("Anulowano");
  // })
  confirmDialog: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      commit("SET_CONFIRM", {
        resolver: resolve,
        rejecter: reject,
        title: params.title,
        content: params.content,
        customButtons: typeof params.customButtons === "undefined" ? null : params.customButtons
      });
    });
  },

  //example
  // let result = this.$store.dispatch('promptDialog', {content: "Test", title: "Confirm test", "placeholder": "Jakis placeholder", "rules":[], model:model, label:"Label input", textarea: false});
  // result.then((resp)=>{
  //     alert("Potwierdzono");
  // }).catch(function () {
  //     alert("Anulowano");
  // })
  promptDialog: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      let promptParams = {
        label: typeof params.label != "undefined" ? params.label : null,
        placeholder: typeof params.placeholder != "undefined" ? params.placeholder : null,
        rules: typeof params.rules != "undefined" ? params.rules : [],
        model: typeof params.model != "undefined" ? params.model : null,
        resolver: resolve,
        textarea: typeof params.textarea != "undefined" ? params.textarea : false,
        rejecter: reject,
        title: params.title,
        content: params.content
      };
      commit("SET_PROMPT", promptParams);
    });
  },

  //example
  //this.$store.dispatch('snackbarPush',{text: 'Test'});
  snackbarPush: ({ commit }, params) => {
    let paramsFilled = {
      position: typeof params.position !== "undefined" && params.position != null ? params.position : "bottom",
      timeout: typeof params.timeout !== "undefined" && params.timeout != null ? params.timeout : 6000,
      text: typeof params.text !== "undefined" && params.text != null ? params.text : "Komunikat nie został uzupełniony",
      color: typeof params.color !== "undefined" && params.color != null ? params.color : "success",
      show: true
    };
    commit("ADD_SNACKBAR", paramsFilled);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
